import { Record as record } from 'immutable';

import trainTime from '../../lib/TrainTime';
import { resolve } from '../../helpers/LinkMapper';


const defaults = {
    id: null,
    amount: 0,
    expiry: null,
    caseReference: null,
    customer: null,
    voucherId: null,
};


class Voucher extends record(defaults) {

    static fromJSON (json = {}) {
        return new Voucher({
            voucherId: resolve(json.id).with(Number),
            customer: resolve(json.customer).with(Number),
            amount: resolve(json.amount).with(Number),
            expiry: resolve(json.expiry).with(trainTime),
            caseReference: resolve(json.caseReference).with(String)
        });
    }

}


export default Voucher;



// WEBPACK FOOTER //
// ./src/records/customer/Voucher.js